import React, { useState } from 'react';
import ConfirmModal from '../Common/ConfirmModal';
import { ccv2Fetch } from '../../services/callcenterV2';

const MODES = [
  { key: 'listen', label: 'Apenas escutar', hint: 'Você ouve a chamada; ninguém percebe.' },
  { key: 'whisper', label: 'Sussurrar', hint: 'Fale apenas com o operador; o cliente não ouve.' },
  { key: 'barge', label: 'Intervir', hint: 'Fale com o operador e o cliente ao mesmo tempo.' },
];

export default function SpyControls({ agentKey, agentName }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('listen');
  const [loading, setLoading] = useState(false);

  const start = async () => {
    setLoading(true);
    try {
      await ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}/spy`, {
        method: 'POST',
        body: JSON.stringify({ mode }),
      });
      setOpen(false);
    } catch (e) {
      const msg = (e && e.body && e.body.message) || (e && e.message) || 'Erro ao iniciar a escuta.';
      alert(`Não foi possível iniciar a escuta: ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="ccv2-action-btn ccv2-action-btn-spy"
        onClick={() => { setMode('listen'); setOpen(true); }}
        disabled={!agentKey}
        title="Entrar em escuta / sussurro"
      >
        Espiar
      </button>
      <ConfirmModal
        open={open}
        title={`Escutar ${agentName || agentKey || 'atendimento'}`}
        confirmLabel="Iniciar escuta"
        loadingLabel="Iniciando..."
        loading={loading}
        onCancel={() => { if (!loading) setOpen(false); }}
        onConfirm={start}
        body={
          <div className="ccv2-spy-modal">
            <div className="ccv2-spy-modes">
              {MODES.map((m) => (
                <label key={m.key} className={`ccv2-spy-mode ${mode === m.key ? 'is-selected' : ''}`}>
                  <input
                    type="radio"
                    name="ccv2-spy-mode"
                    value={m.key}
                    checked={mode === m.key}
                    onChange={() => setMode(m.key)}
                  />
                  <span className="ccv2-spy-mode-label">{m.label}</span>
                  <span className="ccv2-spy-mode-hint">{m.hint}</span>
                </label>
              ))}
            </div>
            <p className="ccv2-spy-note">
              Seu ramal irá tocar; ao atender você entra na escuta no modo selecionado.
            </p>
          </div>
        }
      />
    </>
  );
}
